import { Injectable } from '@angular/core';
import {
  GLSubmissionRoutes,
  Status,
  SubmissionType
} from '@tmhcc-ng-lib/models';

import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  AutoDeclineRequest,
  GlobalVariablesService,
  ReferralCheckRequest,
  StepRequest,
  StepsService
} from '@tmhcc-ng-lib/data-service';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';

@Injectable({
  providedIn: 'root'
})
export class AutoDeclineService {
  constructor(
    private loaderService: LoaderService,
    private globalVariables: GlobalVariablesService,
    private stepsService: StepsService,
    private alertService: AlertTosterService,
    protected router: Router
  ) {}

  declinePolicy(payload: any, formGroup: FormGroup) {
    this.loaderService.show();

    let prodType = this.globalVariables.productName;
    let submissionType = SubmissionType[prodType];

    let declineReq: AutoDeclineRequest = payload;
    this.stepsService.autoDecline(declineReq).subscribe(declineResp => {
      this.loaderService.hide();
      if (declineResp.Status === Status.Success) {
        if (formGroup) formGroup.markAsPristine();
        this.redirectTo(submissionType['Declined']);
      } else {
        this.alertService.error('Something went wrong, please try again');
      }
    });
  }
  referralPolicy(formGroup: FormGroup) {
    let prodType = this.globalVariables.productName;
    let submissionType = SubmissionType[prodType];

    let referralPayload: ReferralCheckRequest = {
      PolicyId: this.globalVariables.policyId,
      VersionNumber: this.globalVariables.policyVersionId,
      PolicyTypeId: this.globalVariables.policyTypeId,
      loggedInUser: this.globalVariables.loggedInUser
    };
    this.stepsService.referralCheck(referralPayload).subscribe(declineResp => {
      this.loaderService.hide();
      if (declineResp.Status === Status.Success) {
        if (formGroup) formGroup.markAsPristine();
        if (
          declineResp.PolicyStatus === Status.PendingReview &&
          declineResp.SubmissionType === Status.EnSubmissionType
        ) {
          this.globalVariables.policyStatus = declineResp.PolicyStatus;
          this.redirectTo(submissionType[declineResp.SubmissionType]);
        } else {
          this.redirectTo(submissionType[declineResp.PolicyStatus]);
        }
      } else {
        this.alertService.error('Something went wrong, please try again');
      }
    });
  }
  redirectTo(uri) {
    this.router.navigate([uri]);
  }
}
